import * as React from "react";

import styles from "./EmptyState.module.css";

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
}

export interface EmptyStateProps {
  icon: string;
  title: string;
  text?: string;
  action?: EmptyStateAction;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, text, action, className }) => (
  <div className={`${styles.root}${className ? ` ${className}` : ""}`}>
    <span className={styles.iconBadge}>
      <i className={`fa-solid ${icon}`} />
    </span>
    <div className={styles.title}>{title}</div>
    {text && <p className={styles.text}>{text}</p>}
    {action && (
      <button type="button" className={styles.actionBtn} onClick={action.onClick}>
        <i className="fa-solid fa-plus" style={{ fontSize: 13 }} />
        {action.label}
      </button>
    )}
  </div>
);
